module.exports = __webpack_public_path__ + "assets/img/00005.054a2655.png";